import userConstants from './loyaltyFooterSection.constants';
import { routeToAnalyticsEventMap } from '../../../../browse/ApplyCardPage/utils/utility';

const handleClickData = (userType = '', pageCategory = '') => {
  const pageValue = routeToAnalyticsEventMap[pageCategory.toLowerCase()];
  const trackingStr = `${userType}-${pageValue}`;
  const analyticsData = {};
  if (userType === userConstants.PLCC_USER) {
    analyticsData.plccItem = trackingStr;
  } else if (userType === userConstants.MPR_USER) {
    analyticsData.mprItem = trackingStr;
  } else {
    analyticsData.guestItem = trackingStr;
  }
  return analyticsData;
};

export default handleClickData;
